import { Flex, Heading, Text } from '@chakra-ui/react'
import { FC } from 'react'
import Lottie from 'react-lottie'

import { ILayoutMessageProps } from '@base/@types/components/Layout/Message'
import animationData from '@base/animations/empty-response.json'

const LayoutEmpty: FC<ILayoutMessageProps> = ({ title, message, type }) => {
  return (
    <Flex h="50vh" flexDir="column" alignItems="center" justifyContent="center">
      <Lottie
        options={{
          loop: false,
          autoplay: true,
          animationData: animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
          }
        }}
        height={120}
        width={200}
      />
      <Heading
        size={type === 'chart' || type === 'homeGrid' ? 'md' : 'lg'}
        mb={2}
        mt={0}
      >
        {title}
      </Heading>
      <Text color="gray.500">{message}</Text>
    </Flex>
  )
}

export default LayoutEmpty
